import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-language-fsharp.svg?component
var programming_language_fsharp_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_language_fsharp_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 128 128"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M0 64.5 60.7 3.8v30.4L30.4 64.5l30.4 30.4v30.4zm39.1 0 21.7-21.7v43.4zm88.9 0L65.1 3.8v30.4l30.4 30.4-30.4 30.3v30.4z" }, null, -1)])]);
}
var programming_language_fsharp_default = { render: render$1 };
//#endregion
export { programming_language_fsharp_default as default, programming_language_fsharp_exports, render$1 as render };

//# sourceMappingURL=programming-language-fsharp.svg.virtual.js.map